module.exports = __webpack_public_path__ + "img/cash-fail.682b3d8a.png";